export const languageLevels = {
  "native" : 4,
  "fluent / business" : 3,
  "conversational" : 2,
  "basic" : 1,
}

export const regretReason = {
  1 : "Does not meet expectation of skills",
  2 : "Does not meet expectation of experience",
  3 : "Other"
}

export const futureYearCount = 10;

export const defaultYear = 1970;

export const scoringCriteria = {
  default: {
    scoringData: [
      {
        'id' : 1,
        'name' : 'Professional Appearance & Attire',
        'value': 0
      },
      {
        'id' : 2,
        'name' : 'Positive Attitude',
        'value': 0
      },
      {
        'id' : 3,
        'name' : 'Listening Skills',
        'value': 0
      },
      {
        'id' : 4,
        'name' : 'Experience',
        'value': 0
      },
      {
        'id' : 5,
        'name' : 'Team Work',
        'value': 0
      },
      {
        'id' : 6,
        'name' : 'Problem Solving',
        'value': 0
      },
      {
        'id' : 7,
        'name' : 'Communication Skills',
        'value': 0
      },
      {
        'id' : 8,
        'name' : 'Motivation to Participate',
        'value': 0
      },
      {
        'id' : 9,
        'name' : 'Analytical',
        'value': 0
      },
      {
        'id' : 10,
        'name' : 'Ability to do the Role & Fit into Culture',
        'value': 0
      }
    ],
    scoringCuttoff: 31,
    totalScore: 50
  },  
};

export const notificationIcons = {
  "SEND_TO_CLIENT" : "initial-candiates",
  "ADD_AND_SEND_TO_CLIENT" : "candidate-add",
  "DECISION_CHANGE_PROGRESS":"mindchange-progress",
  "DECISION_CHANGE_REGRET":"mindchange-regret",
  "REMOVED":"candidate-remove",
  "SEND_TO_RECRUITER":"shortlist-icon",
  "INTERVIEW_ACCEPTED":"notification_interview",
  "INTERVIEW_DECLINED":"notification_interview",
  "CLIENT_INTERVIEW_REQUEST":"notification_interview",
  "RECRUITER_CANDIDATE_INTERVIEW_CONFIRMATION_ACCEPTED":"interview-accepted-icon",
  "RECRUITER_CANDIDATE_INTERVIEW_CONFIRMATION_REJECTED":"interview-rejected-icon",
  "CLIENT_CANDIDATE_INTERVIEW_CONFIRMATION":"interview-accepted-icon",
  "RECRUITER_COLLABORATOR_ADD_NOTIFICATION":"rec-collaborator-icon"
}

export const noticePeriod = {
  "":"Please Select",
  "Immediately Available": "Immediately Available",
  "1 Day":"1 Day Notice Period",
  "1 Week":"1 Week Notice Period",
  "2 Weeks":"2 Weeks Notice Period",
  "3 Weeks":"3 Weeks Notice Period",
  "1 Month":"1 Month Notice Period",
  "2 Months":"2 Months Notice Period",
  "3 Months":"3 Months Notice Period",
  "6 Months": "6 Months Notice Period",
  "6 Months +":" 6 Months + Notice Period"
}
export const jobType = {
  "":"Please Select",
  "Permanent":"Permanent",
  "Contractor":"Contractor",
  "Contractor, Permanent":"Contractor/Permanent"
}

export const locationlist = {
  "Sydney - Australia":"Sydney - Australia",
  "Toronto - Canada":"Toronto - Canada",
  "Shanghai - China":"Shanghai - China",
  "Paris - France":"Paris - France",
  "Hong Kong":"Hong Kong",
  "Cork - Ireland":"Cork - Ireland",
  "Dublin - Ireland":"Dublin - Ireland",
  "Limerick - Ireland":"Limerick - Ireland",
  "Waterford - Ireland":"Waterford - Ireland",
  "Tokyo - Japan":"Tokyo - Japan",
  "Singapore":"Singapore",
  "Bristol - UK":"Bristol - UK",
  "London - UK":"London - UK",
  "Surrey - UK":"Surrey - UK",
  "Sussex - UK":"Sussex - UK",
  "Thames Valley - UK":"Thames Valley - UK"
}

export const WEEK_DAYS = {
  Monday: "Mon",
  Tuesday: "Tue",
  Wednesday: "Wed",
  Thursday: "Thu",
  Friday: "Fri",
  Saturday: "Sat",
  Sunday: "Sun"
}

export const monthName = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const monthShortName = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const TimePeriod = [
  {id:1, value:"09:00:00", label: "09:00am"}, 
  {id:2, value:"09:15:00", label: "09:15am"}, 
  {id:3, value:"09:30:00", label: "09:30am"}, 
  {id:4, value:"09:45:00", label: "09:45am"}, 
  {id:5, value:"10:00:00", label: "10:00am"},
  {id:6, value:"10:15:00", label: "10:15am"}, 
  {id:7, value:"10:30:00", label: "10:30am"}, 
  {id:8, value:"10:45:00", label: "10:45am"}, 
  {id:9, value:"11:00:00", label: "11:00am"},
  {id:10, value:"11:15:00", label: "11:15am"}, 
  {id:11, value:"11:30:00", label: "11:30am"}, 
  {id:12, value:"11:45:00", label: "11:45am"},
  {id:13, value:"12:00:00", label: "12:00pm"}, 
  {id:14, value:"12:15:00", label: "12:15pm"}, 
  {id:15, value:"12:30:00", label: "12:30pm"}, 
  {id:16, value:"12:45:00", label: "12:45pm"}, 
  {id:17, value:"13:00:00", label: "01:00pm"},
  {id:18, value:"13:15:00", label: "01:15pm"}, 
  {id:19, value:"13:30:00", label: "01:30pm"}, 
  {id:20, value:"13:45:00", label: "01:45pm"}, 
  {id:21, value:"14:00:00", label: "02:00pm"},
  {id:22, value:"14:15:00", label: "02:15pm"}, 
  {id:23, value:"14:30:00", label: "02:30pm"}, 
  {id:24, value:"14:45:00", label: "02:45pm"},
  {id:25, value:"15:00:00", label: "03:00pm"}, 
  {id:26, value:"15:15:00", label: "03:15pm"}, 
  {id:27, value:"15:30:00", label: "03:30pm"}, 
  {id:28, value:"15:45:00", label: "03:45pm"}, 
  {id:29, value:"16:00:00", label: "04:00pm"},
  {id:30, value:"16:15:00", label: "04:15pm"}, 
  {id:31, value:"16:30:00", label: "04:30pm"}, 
  {id:32, value:"16:45:00", label: "04:45pm"}
];
export const Durations = [
{id:1, label: "30 mins"}, 
{id:2, label: "1 hour"}, 
{id:3, label: "2 hour"}, 
{id:4, label: "3 hour"}, 
{id:5, label: "4 hour"}]

// Client Portion Updates starts here //
export const SlotPickerDefault = {
  startTime: "900", // means 9 am
  endTime: "445" // means end time 4:45 pm (note end time will always be in PM)
}

export const InterviewType = [
  "First Round Interview"
];

export const ClientCalendarLimit = {
  limit: "14" // calendar limit (no of days)
}

export const SelectionBoxDurations = [
{id:1, label: "30 mins"}, 
{id:2, label: "1 hr"}, 
{id:3, label: "1.5 hr"},
{id:4, label: "2 hr"}, 
{id:5, label: "2.5 hr"}, 
{id:6, label: "3 hr"}];

export const InterviewTypeList = [
  {value:"First round interview",name:"First round interview"}
];

// Client Portion Updates ends here //



// WEBPACK FOOTER //
// ./src/shared/constants.js